import http from "../http"; // مسیر خودت

export const getAdminStores = async (store_name, sort) => {
  try {
    console.log("store = > ", store_name);
    const response = await http.get("/stores/admin-store-manage", {
      params: {
        store_name: store_name,
        sort,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "خطا در دریافت لیست فروشگاه‌ها" };
  }
};

export const changeAdminStoreStatus = async (storeId, payload) => {
  try {
    const response = await http.patch(
      `/stores/admin-store-manage/${storeId}/change-status/`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "خطا در تغییر وضعیت فروشگاه" };
  }
};

export const changeAdminStoreSubscription = async (storeId, payload) => {
  try {
    const response = await http.patch(
      `/stores/admin-store-manage/${storeId}/change-subscription/`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "خطا در بروزرسانی اشتراک فروشگاه" };
  }
};

export const changeAdminStoreSupport = async (storeId, payload) => {
  try {
    const response = await http.patch(
      `stores/${storeId}/assigned_to/`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "خطا در انتصاب پشتیبان" };
  }
};

export const deleteAdminStore = async (storeId) => {
  try {
    const response = await http.delete(
      `/stores/admin-store-manage/${storeId}/delete/`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "خطا در تغییر حذف فروشگاه" };
  }
};

export const getAdminSupportAgents = () => {};
